
import { Api, LocalDictionaryFactory } from  '../../../api/api.module'
import { LoggerService } from  '../../common.module'
import { KpiMeasurementsController } from './kpi.measurements.controller'

//#region Asset Imports

import * as TEMPLATE from './kpi.measurements.tpl.html'

//#endregion

export class KpiMeasurementsDirective {
    scope = {
        source: '=',
        kpiType: '='
    }
    restrict = 'E'
    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary',
        ($scope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory) =>
            new KpiMeasurementsController($scope, $q, $timeout, api, logger, localDictionary)
    ]
    template = TEMPLATE
    replace = true
}